import { ReactElement, Fragment } from 'react';
import { Outlet } from 'react-router-dom';

const Events = (): ReactElement => {
  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};
export default Events;
